import React, { memo, useEffect } from "react";
import * as Yup from "yup";
import { validators } from "investira.sdk";
import { useFormik } from "formik";
import {
  Stack,
  Button,
  Icon,
  TextField,
  LoadingButton,
} from "investira.react.components";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import { VALIDATIONS } from "../../const";

const CarteiraEditForm = memo((props) => {
  const { state, actions } = useCarteirasContext();

  const VALIDATION_SCHEMA = Yup.object().shape({
    carteira: Yup.string()
      .max(128, "Máximo de 128 caracteres")
      .required(VALIDATIONS.REQUIRED),
    carteira_seuid: Yup.string()
      .max(30, "Máximo de 30 caracteres")
      .required(VALIDATIONS.REQUIRED),
  });

  const formik = useFormik({
    initialValues: { carteira: "", carteira_seuid: "" },
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      pActions.setSubmitting(true);

      actions.modifyCarteira(
        { carteira_id: state.carteira_id, ...pValues },
        () => {
          actions.handleModifyCarteiraCancel();
        },
        null,
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  useEffect(() => {
    props.id && actions.readCarteira(props.id);
  }, [props.id]);

  useEffect(() => {
    formik.setValues({
      carteira: state.carteira,
      carteira_seuid: state.carteira_seuid,
    });
  }, [
    state.carteira,
    state.carteira_seuid,
    state.carteira_tipo_id,
    props.mode,
  ]);

  return (
    <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
      <Stack spacing={2}>
        <Stack spacing={2}>
          <Stack flexGrow={1}>
            <TextField
              id="carteira"
              name="carteira"
              label="Carteira"
              value={formik.values.carteira}
              onChange={formik.handleChange}
              placeholder="Digite um nome"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              error={Boolean(formik.errors.carteira)}
              helperText={formik.errors.carteira}
              disabled={formik.isSubmitting}
            />
          </Stack>
          <Stack flexGrow={1}>
            <TextField
              id="carteira_seuid"
              name="carteira_seuid"
              label="SeuID"
              value={formik.values.carteira_seuid}
              onChange={formik.handleChange}
              placeholder="Digite um identificador para a carteira"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              error={Boolean(formik.errors.carteira_seuid)}
              helperText={formik.errors.carteira_seuid}
              disabled={formik.isSubmitting}
              InputProps={{
                readOnly: true,
              }}
            />
          </Stack>
        </Stack>

        <Stack
          flex={1}
          direction="row"
          justifyContent="flex-end"
          sx={{ py: 2 }}
          spacing={2}
        >
          <Button
            variant="outlined"
            type="button"
            color="primary"
            onClick={actions.handleModifyCarteiraCancel}
          >
            Cancelar
          </Button>
          <LoadingButton
            startIcon={<Icon iconName="save" size={16} />}
            variant="contained"
            type="submit"
            loading={formik.isSubmitting}
            disabled={
              validators.isEmpty(formik.values.carteira) ||
              formik.isSubmitting ||
              !formik.isValid
            }
          >
            Salvar
          </LoadingButton>
        </Stack>
      </Stack>
    </form>
  );
});

CarteiraEditForm.displayName = "CarteiraEditForm";

export default CarteiraEditForm;
